import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatARS } from "@/lib/api";

export const CartBar = ({ onOpen }) => {
  const { count, total } = useCart();
  if (!count) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 p-4 backdrop-blur-md bg-[#120E0E]/85 border-t border-[#2E2323]">
      <button onClick={onOpen} data-testid="cart-bar-btn"
        className="max-w-3xl mx-auto w-full flex items-center gap-3 py-3.5 px-5 rounded-full bg-[#DC2626] hover:bg-[#991B1B] text-white shadow-2xl shadow-red-900/50 transition-colors active:scale-[0.99]">
        <span key={count} className="pop relative inline-flex">
          <ShoppingBag className="w-6 h-6" />
          <span className="absolute -top-2 -right-2 min-w-5 h-5 px-1 rounded-full bg-amber-400 text-[#120E0E] text-[11px] font-bold flex items-center justify-center" data-testid="cart-count">{count}</span>
        </span>
        <span className="font-semibold">Ver mi pedido</span>
        <span className="ml-auto font-price text-2xl" data-testid="cart-bar-total">{formatARS(total)}</span>
      </button>
    </div>
  );
};
